
import React, { useEffect, useState } from 'react';
import QRCode from "react-qr-code";
import Modal from 'react-modal';
import FileBase64 from 'react-file-base64';
import { useDoubleTap } from 'use-double-tap';
import { Helmet } from 'react-helmet';
//import './static.toss.im_tps_others.css';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};


function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function numberToYYYYMMDD(x) {
    const year = Math.floor(x / 10000);
    const month = Math.floor((x % 10000) / 100);
    const day = x % 100;
  
    return `${year}년 ${month}월 ${day}일`;
  }
  

export default function Home() {

    const [name, setName] = useState('홍길동');
    const [amount, setAmount] = useState(1000);
    const [toAccount, setToAccount] = useState('KB국민 1234567890');
    const [ymd, setYMD] = useState("20230219");
    const [hm, setHM] = useState("15:03");
    const printRef = React.useRef();

    const handleDownloadImage = () => {
        const element = document.getElementById('element-to-capture');
    
        // Set options for rendering
        const options = {
          width: 375,          // Desired width
          height: 812,
          quality: 2.0,      // Desired height
          style: {
            transform: 'scale(1)' // Scale the element for higher resolution
          },
          filter: node => {
            // Apply a white background if needed (optional)
            return node.tagName !== 'BODY';
          },
          quality: 1,          // JPEG quality (1 for highest quality)
          imagePlaceholder: true, // Use image placeholders for non-image elements (optional)
        };

        const scale = 3    
const style = {
    transform: 'scale('+scale+')',
    transformOrigin: 'top left',
    width: element.offsetWidth + "px",
     height: element.offsetHeight + "px"
}

const param = {
     height: element.offsetHeight * scale,
     width: element.offsetWidth * scale,
      quality: 1,
     style
}



    
        // Capture the element and convert it to a PNG image with the specified options
        domtoimage.toJpeg(element, param)
          .then(function (dataUrl) {
            // Convert the data URL to a downloadable link
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = 'image.jpg'; // Use PNG for high-quality images
            link.click();
          });
      };
    return (
        <>
            <Helmet>
                <title>Toss by Junwoo</title>
                <link href='//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSansNeo.css' rel='stylesheet' type='text/css'></link>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="apple-touch-fullscreen" content="yes" />
                <meta name="apple-mobile-web-app-status-bar-style" content="white" />
                <meta name="theme-color" content="#fff"></meta>

            </Helmet>
            <style
                dangerouslySetInnerHTML={{
                    __html:
                        'body {background-color: #F2F4F6}\n        #progress-bar {\n            width: 274px;\n            height: 5px;\n            border-radius: 2px;\n            background-color: #D9D9D9;\n        }\n\n        #progress {\n            width: 0%;\n            height: 100%;\n            border-radius: 2px;\n            background: linear-gradient(to right, #71ADF5, #5B3EFF);\n        }\n        \n.inactiveMixin {\n  content: "";\n  position: absolute;\n  display: block;\n}\n.beforeAnimation {\n  transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);\n}\n.afterAnimation {\n  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 0px 0 hsla(0, 0%, 0%, 0.04), 0 4px 9px hsla(0, 0%, 0%, 0.13), 0 3px 3px hsla(0, 0%, 0%, 0.05);\n  transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);\n}\n.toggleWrapper {\n  margin-top: 42px;\n  \n}\n.toggleWrapper input.mobileToggle {\n  opacity: 0;\n  position: absolute;\n}\n.toggleWrapper input.mobileToggle + label {\n  position: relative;\n  display: inline-block;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  transition: 0.4s ease;\n  height: 30px;\n  width: 50px;\n  border: 1px solid #e4e4e4;\n  border-radius: 60px;\n}\n.toggleWrapper input.mobileToggle + label:before {\n  content: "";\n  position: absolute;\n  display: block;\n  transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);\n  height: 30px;\n  width: 51px;\n  top: 0;\n  left: 0;\n  border-radius: 30px;\n}\n.toggleWrapper input.mobileToggle + label:after {\n  content: "";\n  position: absolute;\n  display: block;\n  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 0px 0 hsla(0, 0%, 0%, 0.04), 0 4px 9px hsla(0, 0%, 0%, 0.13), 0 3px 3px hsla(0, 0%, 0%, 0.05);\n  transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);\n  background: #FFF;\n  height: 28px;\n  width: 28px;\n  top: 1px;\n  left: 0px;\n  border-radius: 60px;\n}\n.toggleWrapper input.mobileToggle:checked + label:before {\n  background: #222;\n  transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);\n}\n.toggleWrapper input.mobileToggle:checked + label:after {\n  left: 24px;\n}\n\n    '
                }}
            />
<BrowserView>
            <div className='flex flex-row justify-center' style={{backgroundColor: "#F2F4F6"}} id='main'>
                <div style={{flex:3, maxWidth:375, backgroundColor: "#F2F4F6"}}ref={printRef} id="element-to-capture" className='flex flex-col'>
                    <nav className="bg-white">
                        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                            <div className="relative flex h-10 pt-6 items-center justify-between">
                                <div className="">
                                    {/* Mobile menu button*/}
                                    <div
                                        className="inline-flex items-center justify-center rounded-md text-black hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                        aria-controls="mobile-menu"
                                        aria-expanded="false"
                                    >
                                        <svg
                                            className="block h-6 w-6"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                            <g
                                                id="SVGRepo_tracerCarrier"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <g id="SVGRepo_iconCarrier">
                                                {" "}
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z"
                                                    fill="#000000"
                                                />{" "}
                                            </g>
                                        </svg>

                                    </div>
                                </div>
                                <div className="">
                                    <div className="flex flex-shrink-0 items-center">
                                        <div className="text-black text-base" style={{ color: "#353C49", fontWeight: "500" }}>{"상세 내역"}</div>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="flex flex-shrink-0 items-center">
                                        <div className="text-black text-base" style={{ color: "#353C49", fontWeight: "400" }}>{"숨기기"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-7" />
                    </nav>
                    <div className="flex flex-col pt-16" style={{ backgroundColor: "#FFF" }}>

                        <div className='px-6'>

                            <div>
                                <p style={{ color: "#4e5968", fontSize: 14, fontWeight: 400 }}>{name}</p>
                                <p style={{ color: "#333D4B", fontSize: 30, fontWeight: 500 }}>+{numberWithCommas(amount)}원</p>

                            </div>

                            <div className="flex flex-row pt-14 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>카테고리 설정</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#3182f6", fontSize: 16, fontWeight: 400 }}>이체</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>

                            </div>

                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>메모</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#3182f6", fontSize: 16, fontWeight: 400 }}>메모를 남겨보세요</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>
                            </div>
                            <div className="flex flex-row pt-7 justify-between">
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>수입 합계에 포함</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}></p>
                                    <div class="relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
                                        <div  style={{right:1, borderColor: "#3182f6"}} class="toggle-checkbox absolute block w-7 h-7 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                                        <label style={{backgroundColor: "#3182f6"}} for="toggle" class="toggle-label block overflow-hidden h-7 rounded-full bg-gray-300 cursor-pointer"></label>
                                    </div></div>
                            </div>
                        </div>


                        <div style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.06)', marginLeft: 24 }} className="flex flex-row pb-7 justify-between">

                        </div>

                        <div className='px-6'>

                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>입금처</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}>내 {toAccount}</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>
                            </div>

                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>출금처</p>
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}>{name}</p>

                            </div>
                            <div className="flex flex-row pt-7 justify-between">
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>이체일시</p>
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}>{numberToYYYYMMDD(ymd)} {hm}</p>

                            </div>
                            <div className="flex flex-row pt-7 pb-6 justify-between">
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>송금확인증</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}>발급받기</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>
                            </div>
                        </div>

                    </div>


                    <div className="flex flex-col mt-3" style={{ backgroundColor: "#FFF" }}>

                        <div className='px-6 pb-10'>
                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>최근 3개월간 거래 내역</p>

                            </div>

                            <div className='flex flex-row justify-around'>
                                <div className="flex flex-col pt-7 items-center	">
                                    <p style={{ color: "#4e5968", fontSize: 14, fontWeight: 300 }}>거래 횟수</p>
                                    <p style={{ color: "black", fontSize: 16, fontWeight: 500 }}>1회</p>

                                </div>

                                <div className="flex flex-col pt-7 items-center	">
                                    <p className='' style={{ color: "#4e5968", fontSize: 14, fontWeight: 300 }}>총 금액</p>
                                    <p className='' style={{ color: "#3182f6", fontSize: 16, fontWeight: 500 }}>+{numberWithCommas(amount)}원</p>

                                </div></div>

                        </div>


                    </div>
                </div>

                <div style={{ backgroundColor: "" }} className='flex'>
                    <div style={{flex: 2}} className="p-6">                    <p style={{ color: "black", fontSize: 16, fontWeight: 500 }}>토스 이체내역 온라인 생성기</p>
                    <p style={{ color: "#333D4B", fontSize: 14, fontWeight: 400 }}>@kjw55792</p>

                        <div className="pt-2">
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <div className="flex -mr-px">
                                </div>
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded px-3 relative focus:border-blue focus:shadow"
                                    placeholder="출금처 이름"
                                    onChange={e => setName(e.target.value)}
                                    value={name}
                                />
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <div className="flex -mr-px">
                                </div>
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded px-3 relative focus:border-blue focus:shadow"
                                    placeholder="입금처 (계좌)"
                                    onChange={e => setToAccount(e.target.value)}
                                    value={toAccount}
                                />
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                    placeholder="금액 (숫자만)"
                                    onChange={e => setAmount(e.target.value)}
                                    value={amount}
                                />
                                <div className="flex -mr-px">
                                    <span className="flex items-center leading-normal bg-white rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm">
                                        원
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                    placeholder="날짜"
                                    onChange={e => setYMD(e.target.value)}
                                    value={ymd}
                                />
                                <div className="flex -mr-px">
                                    <span className="flex items-center leading-normal bg-white rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm">
                                        예)20230929
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                    placeholder="시간"
                                    onChange={e => setHM(e.target.value)}
                                    value={hm}
                                />
                                <div className="flex -mr-px">
                                    <span className="flex items-center leading-normal bg-white rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm">
                                        예)13:21
                                    </span>
                                </div>
                            </div>

                        </div>
                        <button className='w-max' onClick={handleDownloadImage}
  type="button" style={{backgroundColor: "#3182f6", width: "-webkit-fill-available"}}
  class="inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]">
  캡쳐 후 다운로드
</button>

<div className='pt-2'>
                                <p style={{ color: "#4e5968", fontSize: 14, fontWeight: 400 }}>현재 브라우저 모드입니다.</p>

                            </div>
                    </div>

                </div>
            </div></BrowserView>

<MobileView>
<div className='flex flex-col-reverse justify-center' style={{backgroundColor: "#F2F4F6"}} id='main'>
                <div style={{backgroundColor: "#F2F4F6"}}ref={printRef} id="element-to-capture" className='flex flex-col'>
                    <nav className="bg-white">
                        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                            <div className="relative flex h-10 pt-6 items-center justify-between">
                                <div className="">
                                    {/* Mobile menu button*/}
                                    <div
                                        className="inline-flex items-center justify-center rounded-md text-black hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                        aria-controls="mobile-menu"
                                        aria-expanded="false"
                                    >
                                        <svg
                                            className="block h-6 w-6"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                            <g
                                                id="SVGRepo_tracerCarrier"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <g id="SVGRepo_iconCarrier">
                                                {" "}
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z"
                                                    fill="#000000"
                                                />{" "}
                                            </g>
                                        </svg>

                                    </div>
                                </div>
                                <div className="">
                                    <div className="flex flex-shrink-0 items-center">
                                        <div className="text-black text-base" style={{ color: "#353C49", fontWeight: "500" }}>{"상세 내역"}</div>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="flex flex-shrink-0 items-center">
                                        <div className="text-black text-base" style={{ color: "#353C49", fontWeight: "400" }}>{"숨기기"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-7" />
                    </nav>
                    <div className="flex flex-col pt-16" style={{ backgroundColor: "#FFF" }}>

                        <div className='px-6'>

                            <div>
                                <p style={{ color: "#4e5968", fontSize: 14, fontWeight: 400 }}>{name}</p>
                                <p style={{ color: "#333D4B", fontSize: 30, fontWeight: 500 }}>+{numberWithCommas(amount)}원</p>

                            </div>

                            <div className="flex flex-row pt-14 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>카테고리 설정</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#3182f6", fontSize: 16, fontWeight: 400 }}>이체</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>

                            </div>

                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>메모</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#3182f6", fontSize: 16, fontWeight: 400 }}>메모를 남겨보세요</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>
                            </div>
                            <div className="flex flex-row pt-7 justify-between">
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>수입 합계에 포함</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}></p>
                                    <div class="relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
                                        <div  style={{right:1, borderColor: "#3182f6"}} class="toggle-checkbox absolute block w-7 h-7 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                                        <label style={{backgroundColor: "#3182f6"}} for="toggle" class="toggle-label block overflow-hidden h-7 rounded-full bg-gray-300 cursor-pointer"></label>
                                    </div></div>
                            </div>
                        </div>


                        <div style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.06)', marginLeft: 24 }} className="flex flex-row pb-7 justify-between">

                        </div>

                        <div className='px-6'>

                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>입금처</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{textDecorationLine:"none",  WebkitTextDecorationSkip:"none",WebkitTextDecorationSkip: "none", /* Safari */ textDecorationSkipInk: "none", color: "#333D4B", fontSize: 16, fontWeight: 300 }}>내 {toAccount}</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>
                            </div>

                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>출금처</p>
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}>{name}</p>

                            </div>
                            <div className="flex flex-row pt-7 justify-between">
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>이체일시</p>
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}>{numberToYYYYMMDD(ymd)} {hm}</p>

                            </div>
                            <div className="flex flex-row pt-7 pb-6 justify-between">
                                <p className='' style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>송금확인증</p>
                                <div className='flex flex-row '>                        <p className='pr-3' style={{ color: "#333D4B", fontSize: 16, fontWeight: 300 }}>발급받기</p>
                                    <svg
                                        className="block h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M10 7L15 12L10 17"
                                                stroke="#b0b8c1"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />{" "}
                                        </g>
                                    </svg></div>
                            </div>
                        </div>

                    </div>


                    <div className="flex flex-col mt-3" style={{ backgroundColor: "#FFF" }}>

                        <div className='px-6 pb-10'>
                            <div className="flex flex-row pt-7 justify-between">
                                <p style={{ color: "#333D4B", fontSize: 16, fontWeight: 400 }}>최근 3개월간 거래 내역</p>

                            </div>

                            <div className='flex flex-row justify-around'>
                                <div className="flex flex-col pt-7 items-center	">
                                    <p style={{ color: "#4e5968", fontSize: 14, fontWeight: 300 }}>거래 횟수</p>
                                    <p style={{ color: "black", fontSize: 16, fontWeight: 500 }}>1회</p>

                                </div>

                                <div className="flex flex-col pt-7 items-center	">
                                    <p className='' style={{ color: "#4e5968", fontSize: 14, fontWeight: 300 }}>총 금액</p>
                                    <p className='' style={{ color: "#3182f6", fontSize: 16, fontWeight: 500 }}>+{numberWithCommas(amount)}원</p>

                                </div></div>

                        </div>

                    </div>
                </div>

                <div style={{ backgroundColor: "" }}>
                    <div  className="p-6">                    <p style={{ color: "black", fontSize: 16, fontWeight: 500 }}>토스 이체내역 온라인 생성기</p>
                    <p style={{ color: "#333D4B", fontSize: 14, fontWeight: 400 }}>@kjw55792</p>
                        <div className="pt-2">
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <div className="flex -mr-px">
                                </div>
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded px-3 relative focus:border-blue focus:shadow"
                                    placeholder="출금처 이름"
                                    onChange={e => setName(e.target.value)}
                                    value={name}
                                />
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <div className="flex -mr-px">
                                </div>
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded px-3 relative focus:border-blue focus:shadow"
                                    placeholder="입금처 (계좌)"
                                    onChange={e => setToAccount(e.target.value)}
                                    value={toAccount}
                                />
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                    placeholder="금액 (숫자만)"
                                    onChange={e => setAmount(e.target.value)}
                                    value={amount}
                                />
                                <div className="flex -mr-px">
                                    <span className="flex items-center leading-normal bg-white rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm">
                                        원
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                    placeholder="날짜"
                                    onChange={e => setYMD(e.target.value)}
                                    value={ymd}
                                />
                                <div className="flex -mr-px">
                                    <span className="flex items-center leading-normal bg-white rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm">
                                        예)20230929
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-wrap items-stretch w-full mb-4 relative">
                                <input
                                    type="text"
                                    className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                    placeholder="시간"
                                    onChange={e => setHM(e.target.value)}
                                    value={hm}
                                />
                                <div className="flex -mr-px">
                                    <span className="flex items-center leading-normal bg-white rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm">
                                        예)13:21
                                    </span>
                                </div>
                            </div>

                        </div>
                        <button className='w-max' onClick={handleDownloadImage}
  type="button" style={{backgroundColor: "#3182f6", width: "-webkit-fill-available"}}
  class="inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]">
  캡쳐 후 다운로드
</button>

<div className='pt-2'>
                                <p style={{ color: "#4e5968", fontSize: 14, fontWeight: 400 }}>현재 모바일 모드입니다.</p>

                            </div>
                    </div>

                </div>
            </div></MobileView>

        </>



    )
}
